/**
 * Используется для приостановки выполнения кода на определённый период времени
 * @param { number } ms - Длительность задержки в миллисекундах
 */
function sleep(ms: number) {
  return new Promise(resolve => { setTimeout(resolve, ms) })
}

export default sleep
